module.exports = __webpack_public_path__ + "img/Residential_Commercial - Kankavli.270ef2c9.jpg";